import WidgetConfigEditor from "@/components/WidgetConfigEditor";
import { useUpdateWidgetConfig, useWidgetConfig } from "@/hooks/useWidgetConfigs";
import { PageHeader } from "@/components/ui";

const SettingsWidget = () => {
  const updateMutation = useUpdateWidgetConfig();
  const { data: config, isLoading } = useWidgetConfig(null);

  if (isLoading) {
    return (
      <div className="page">
        <PageHeader
          label="Settings"
          title="Widget Settings"
          description="Configure the assistant widget appearance and behavior."
        />
        <div className="card">
          <div className="card-b">
            <p className="meta" style={{ textAlign: "center", padding: "32px 0" }}>
              Loading...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <PageHeader
        label="Settings"
        title="Widget Settings"
        description="Configure the assistant widget appearance and behavior."
      />

      <WidgetConfigEditor
        publicKey={null}
        initialOverrides={config?.overrides}
        isSaving={updateMutation.isPending}
        onSave={(overrides) => updateMutation.mutate({ publicKey: null, overrides })}
      />
    </div>
  );
};

export default SettingsWidget;
